export const FeeScheduleFragment = gql`
  fragment FeeScheduleFragment on FeeSchedule {
    id
    effectiveDate
    hasFutureFeeSchedule
    isCurrent
    name
    notDeletableReason
    numUnarchivedFeeTemplates
  }
`
